import { __rest } from "tslib";
import { Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef } from 'react';
import { createReactWrapper } from '../common/PrefixUtils';
import { handleForwardRef } from '../common/RefUtils';
import '@getgo/chameleon-web/components/SidePanel/register';
import { addExtraProps } from '../common/utils/AddExtraProps';
export const SidePanel = forwardRef((_a, ref) => {
    var { children, onClose, onClosing, onOpening, onBack, onClickOutside, toolbar, footer, headingStart, headingEnd, closeLabel, backLabel, closesOnClickOutside, isOpen } = _a, props = __rest(_a, ["children", "onClose", "onClosing", "onOpening", "onBack", "onClickOutside", "toolbar", "footer", "headingStart", "headingEnd", "closeLabel", "backLabel", "closesOnClickOutside", "isOpen"]);
    const sidePanelRef = useRef();
    const handledRef = handleForwardRef(sidePanelRef, ref);
    useEffect(() => {
        var _a;
        const handleClose = () => {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        };
        (_a = sidePanelRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('close', handleClose);
        return () => {
            var _a;
            (_a = sidePanelRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('close', handleClose);
        };
    }, [onClose]);
    useEffect(() => {
        var _a;
        const handleOpening = () => {
            onOpening === null || onOpening === void 0 ? void 0 : onOpening();
        };
        (_a = sidePanelRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('opening', handleOpening);
        return () => {
            var _a;
            (_a = sidePanelRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('opening', handleOpening);
        };
    }, [onOpening]);
    useEffect(() => {
        var _a;
        const handleClosing = () => {
            onClosing === null || onClosing === void 0 ? void 0 : onClosing();
        };
        (_a = sidePanelRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('closing', handleClosing);
        return () => {
            var _a;
            (_a = sidePanelRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('closing', handleClosing);
        };
    }, [onClosing]);
    useEffect(() => {
        var _a;
        const handleGoBack = () => {
            onBack === null || onBack === void 0 ? void 0 : onBack();
        };
        (_a = sidePanelRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('go-back', handleGoBack);
        return () => {
            var _a;
            (_a = sidePanelRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('go-back', handleGoBack);
        };
    }, [onBack]);
    useEffect(() => {
        var _a;
        const handleClickOutside = () => {
            onClickOutside === null || onClickOutside === void 0 ? void 0 : onClickOutside();
        };
        (_a = sidePanelRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('click-outside', handleClickOutside);
        return () => {
            var _a;
            (_a = sidePanelRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('click-outside', handleClickOutside);
        };
    }, [onClickOutside]);
    return createReactWrapper({
        tagName: 'chameleon-side-panel',
        props: Object.assign(Object.assign({}, props), { 'closes-on-click-outside': closesOnClickOutside, 'back-label': backLabel, 'close-label': closeLabel, 'is-open': isOpen, ref: handledRef }),
        children: (_jsxs(_Fragment, { children: [headingStart ? addExtraProps(headingStart, { slot: 'heading-start' }) : null, headingEnd ? addExtraProps(headingEnd, { slot: 'heading-end' }) : null, toolbar ? addExtraProps(toolbar, { slot: 'toolbar' }) : null, footer ? addExtraProps(footer, { slot: 'footer' }) : null, children] })),
    });
});
